/* OL SUPPORT-CHAT - die Bedienung.  Neu aufgebaut 08.10.
 *
 * WARUM EIGENE DATEI: Markup, Stil und Bedienung lagen zusammen in
 * sections/ol-hilfe-chat.liquid, 22 KB. Mit dem Werkzeug, mit dem
 * dieses Theme gepflegt wird, liess sich die Datei nicht mehr am
 * Stueck zurueckschreiben; jede Aenderung war damit blockiert. Jetzt:
 *   sections/ol-hilfe-chat.liquid  Geruest und Uebersetzungen
 *   assets/ol-hilfe.css            das ganze Aussehen
 *   assets/ol-hilfe-ui.js          diese Datei
 *   assets/ol-hilfe.js             das Suchverfahren
 *   assets/ol-hilfe-<sprache>.js   das Wissen, nur eine Sprache
 *
 * DIE TEXTE kommen als JSON im Geruest mit. Der t-Filter maskiert HTML,
 * darum laeuft jede Zeichenkette einmal durch entziffer() - sonst liest
 * der Kunde woertlich "all&#39;assistenza". Geschrieben wird
 * ausschliesslich ueber textContent; es gibt in dieser Datei kein
 * einziges innerHTML.
 *
 * DAS SCHREIBT-GERADE ist kein Zierrat: die Antwort kaeme sofort, und
 * eine Antwort ohne jede Verzoegerung liest sich wie ein Formular, das
 * umgeblaettert hat. Die 420 ms geben dem Gespraech einen Takt. Wer
 * weniger Bewegung eingestellt hat, bekommt sie trotzdem - nur ohne
 * huepfende Punkte (siehe ol-hilfe.css).
 */
(function () {
  'use strict';

  var ENT = {
    '&amp;': '&', '&#39;': "'", '&#x27;': "'", '&quot;': '"',
    '&#34;': '"', '&lt;': '<', '&gt;': '>', '&nbsp;': ' '
  };

  function entziffer(s) {
    if (typeof s !== 'string' || s.indexOf('&') < 0) return s;
    return s.replace(/&(amp|#39|#x27|quot|#34|lt|gt|nbsp);/g, function (m) {
      return ENT[m] !== undefined ? ENT[m] : m;
    });
  }

  function starte(wurzel) {
    if (wurzel.dataset.bereit) return;
    wurzel.dataset.bereit = '1';

    var rohtexte = {};
    var topf = wurzel.querySelector('[data-ol-hc-texte]');
    try { rohtexte = JSON.parse(topf.textContent) || {}; } catch (e) { rohtexte = {}; }

    var T = {};
    for (var k in rohtexte) { T[k] = entziffer(rohtexte[k]); }

    var sprache = wurzel.getAttribute('data-sprache') || 'de';
    var basis = (wurzel.getAttribute('data-wurzel') || '/').replace(/\/$/, '');
    var kontakt = wurzel.getAttribute('data-kontakt') || '/pages/contact';

    var start = wurzel.querySelector('[data-ol-hc-start]');
    var panel = wurzel.querySelector('[data-ol-hc-panel]');
    var zu = wurzel.querySelector('[data-ol-hc-zu]');
    var neu = wurzel.querySelector('[data-ol-hc-neu]');
    var lauf = wurzel.querySelector('[data-ol-hc-lauf]');
    var form = wurzel.querySelector('[data-ol-hc-form]');
    var ein = wurzel.querySelector('[data-ol-hc-ein]');
    var begonnen = false;

    function weg(u) {
      if (!u) return '#';
      if (/^https?:/i.test(u)) return u;
      return basis + u;
    }

    function wissen() {
      var w = window.olHilfeWissen;
      return (w && w[sprache]) || (w && w.de) || [];
    }

    function nachUnten() { lauf.scrollTop = lauf.scrollHeight; }

    function blase(text, wer, knoten) {
      var d = document.createElement('div');
      d.className = 'ol-hc__blase ol-hc__blase--' + wer;
      var marke = document.createElement('span');
      marke.className = 'visually-hidden';
      marke.textContent = (wer === 'du' ? T.du : T.wir) + ': ';
      d.appendChild(marke);
      if (text) {
        var p = document.createElement('p');
        p.textContent = text;
        d.appendChild(p);
      }
      if (knoten) d.appendChild(knoten);
      lauf.appendChild(d);
      nachUnten();
      return d;
    }

    /* Drei Punkte, die wieder verschwinden. Gibt die Blase zurueck,
       damit der Aufrufer sie genau dann abraeumt, wenn die Antwort
       steht - nicht frueher, sonst springt der Verlauf. */
    function tippt() {
      var d = document.createElement('div');
      d.className = 'ol-hc__blase ol-hc__blase--wir';
      var reihe = document.createElement('div');
      reihe.className = 'ol-hc__tippt';
      reihe.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < 3; i++) reihe.appendChild(document.createElement('i'));
      d.appendChild(reihe);
      lauf.appendChild(d);
      nachUnten();
      return d;
    }

    function knopfReihe(eintraege, ueberschrift) {
      var huelle = document.createElement('div');
      if (ueberschrift) {
        var h = document.createElement('p');
        h.className = 'ol-hc__zwischen';
        h.textContent = ueberschrift;
        huelle.appendChild(h);
      }
      var reihe = document.createElement('div');
      reihe.className = 'ol-hc__chips';
      eintraege.forEach(function (e) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ol-hc__chip';
        b.textContent = e.t;
        b.addEventListener('click', function () { frage(e.t, e); });
        reihe.appendChild(b);
      });
      huelle.appendChild(reihe);
      return huelle;
    }

    function antwortKnoten(e) {
      var huelle = document.createElement('div');
      var h = document.createElement('p');
      h.className = 'ol-hc__betreff';
      h.textContent = e.t;
      huelle.appendChild(h);
      var a = document.createElement('p');
      a.textContent = e.a;
      huelle.appendChild(a);
      if (e.l) {
        var link = document.createElement('a');
        link.className = 'ol-hc__link';
        link.href = weg(e.l.u);
        link.textContent = e.l.t;
        huelle.appendChild(link);
      }
      return huelle;
    }

    function menschKnoten() {
      var link = document.createElement('a');
      link.className = 'ol-hc__mensch';
      link.href = weg(kontakt);
      link.textContent = T.mensch;
      return link;
    }

    function antworte(text, direkt) {
      var eintraege = wissen();

      if (direkt) {
        blase(null, 'wir', antwortKnoten(direkt));
        return;
      }
      if (!eintraege.length || !window.olHilfe) {
        var leer = document.createElement('div');
        leer.appendChild(menschKnoten());
        blase(T.nichts, 'wir', leer);
        return;
      }

      var r = window.olHilfe.antworte(text, eintraege);
      if (r.art === 'treffer') {
        var k = antwortKnoten(r.eintrag);
        if (r.weitere && r.weitere.length) k.appendChild(knopfReihe(r.weitere, T.themen));
        k.appendChild(menschKnoten());
        blase(null, 'wir', k);
        return;
      }

      var huelle = document.createElement('div');
      huelle.appendChild(knopfReihe(r.vorschlaege || [], null));
      huelle.appendChild(menschKnoten());
      blase(r.art === 'nichts' ? T.nichts : T.unsicher, 'wir', huelle);
    }

    function frage(text, direkt) {
      if (!text) return;
      blase(text, 'du');
      var punkte = tippt();
      setTimeout(function () {
        punkte.remove();
        antworte(text, direkt);
      }, 420);
    }

    function eroeffne(erzwingen) {
      if (begonnen && !erzwingen) return;
      begonnen = true;
      if (erzwingen) lauf.textContent = '';
      var vorschau = wissen().slice(0, 5);
      blase(T.gruss, 'wir', vorschau.length ? knopfReihe(vorschau, T.themen) : null);
    }

    function oeffne() {
      panel.hidden = false;
      wurzel.classList.add('ist-offen');
      start.setAttribute('aria-expanded', 'true');
      eroeffne(false);
      setTimeout(function () { ein.focus(); }, 60);
    }

    function schliesse() {
      panel.hidden = true;
      wurzel.classList.remove('ist-offen');
      start.setAttribute('aria-expanded', 'false');
      start.focus();
    }

    start.addEventListener('click', function () {
      if (panel.hidden) oeffne(); else schliesse();
    });
    zu.addEventListener('click', schliesse);
    if (neu) {
      neu.addEventListener('click', function () {
        eroeffne(true);
        ein.value = '';
        ein.focus();
      });
    }

    /* ESC gehoert dem Chat nur, solange er offen ist - sonst nimmt er
       anderen Fenstern auf der Seite die Taste weg. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || panel.hidden) return;
      e.stopPropagation();
      schliesse();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var t = ein.value.trim();
      if (!t) return;
      ein.value = '';
      frage(t, null);
    });
  }

  function alle() {
    var liste = document.querySelectorAll('[data-ol-hc]');
    for (var i = 0; i < liste.length; i++) starte(liste[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  /* Im Theme-Editor wird der Abschnitt neu gezeichnet; dann steht ein
     frisches Geruest ohne data-bereit da und will erneut gebunden
     werden. */
  document.addEventListener('shopify:section:load', alle);
})();
